<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Pesquisar por Nome ou ID">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-2 ml-2 btn-sm btn-outline" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="account-step">Passo</label>
          <select v-model="query.step" id="account-step" class="form-control">
            <option v-for="option in filterStep.table" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-app-name">App</label>
          <select v-model="query.appName" type="date" id="account-app-name" class="form-control">
            <option v-for="option in filterAppName.table" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-app-status">Status do app</label>
          <select v-model="query.accountAppStatus" id="account-app-status" class="form-control">
            <option v-for="option in filterAccountAppStatus.table" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-account-type">Tipo de conta</label>
          <select v-model="query.accountType" id="account-account-type" class="form-control">
            <option v-for="option in filterAcccountType.table" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-subscription-type">Status da conta</label>
          <select v-model="query.subscriptionType" id="account-subscription-type" class="form-control">
            <option v-for="option in filterSubscriptionType.table" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-tags">Tags</label>
          <select
            id="account-tags"
            class="form-control"
            :value="''"
            @change="addTagFilter($event.target.value)"
            :disabled="!availableTagOptions.length"
          >
            <option value="">{{ tags.length ? 'Selecione uma tag' : 'Nenhuma tag criada' }}</option>
            <option v-for="tag in availableTagOptions" :key="tag.id" :value="tag.id">
              {{ tag.name }}
            </option>
          </select>
          <div v-if="query.tagIds.length" class="selected-tags mt-2">
            <span
              v-for="tagId in query.tagIds"
              :key="tagId"
              class="tag-badge"
              :style="{ backgroundColor: `#${tagColor(tagId)}`, color: tagTextColor(tagColor(tagId)) }"
            >
              {{ tagName(tagId) }}
              <span class="tag-badge-remove" @click="removeTagFilter(tagId)" title="Remover">&times;</span>
            </span>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="account-period-type">Tipo de data</label>
          <select v-model="query.periodType" id="account-period-type" class="form-control">
            <option value="created_at">Criado em</option>
            <option value="updated_at">Atualizado em</option>
            <option value="app_expiration_at">Expiração do período de teste</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="account-start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="account-end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="account-end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1" @click="sendPartnerAccount()">
          Criar conta parceira
        </button>
        <button class="btn btn-primary mt-1 mr-1" @click="createReport" :disabled="disabledReport">
          Baixar relatório
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>

        <button class="btn btn-outline ml-3 mb-1" v-if="accounts.length > 0" @click="changeCheckAll"
          :class="{ 'btn-outline-active': checkAll }">
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <button class="btn btn-outline mr-3" style="white-space: nowrap" @click="showSelectColumns = true">
            Mostrar colunas
          </button>
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
            <option value="name">Nome</option>
            <option value="id">ID</option>
            <option value="app_expiration_at">Expiração do período de teste</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow" />
              </th>
              <th v-for="column in selectedColumns" :key="column.key">{{ column.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="`${row.account.id}-${row.appKey}-${index}`">
              <td>
                <BkpsCheckBox v-model="row.account.checked" @input="changeCheckRow" />
              </td>
              <td v-for="column in selectedColumns" :key="column.key">
                <template v-if="column.key === 'actions'">
                  <router-link :to="buildLink(row.account)" class="btn btn-primary">
                    Editar
                  </router-link>
                </template>
                <template v-else-if="column.key === 'accountStatus'">
                  <span class="badge" :class="accountStatusBadgeClass(row.account.subscriptionType)">
                    {{ translateAccountStatus(row.account.subscriptionType) }}
                  </span>
                </template>
                <template v-else-if="column.key === 'appStatus'">
                  <span v-if="row.app && row.app.status" class="badge" :class="appStatusBadgeClass(row.app.status)">
                    {{ appStatusLabel(row.app.status) }}
                  </span>
                  <span v-else>-</span>
                </template>
                <template v-else-if="column.key === 'tags'">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="tags-cell">
                      <span
                          v-for="tag in accountTags(row.account).slice(0, 6)"
                          :key="tag.id"
                          class="tag-badge"
                          :style="{ backgroundColor: `#${tag.color}`, color: tagTextColor(tag.color) }"
                          v-tooltip.top="tag.name"
                      >
                        {{ tag.name }}
                      </span>
                      <span v-if="accountTags(row.account).length > 6" class="align-self-center ml-1">
                        (+{{ accountTags(row.account).length - 6 }})
                      </span>
                    </div>
                    <AccountTagsPopover
                        class="ml-2 align-self-center"
                        :tags="tags"
                        :tagIds="accountTagIds(row.account)"
                        @associateTags="associateTags(row.account, $event)"
                        @deletedTag="refreshTags()"
                        @changeTags="refreshTags()"
                    />
                  </div>
                </template>
                <template v-else>{{ cellValue(row, column) }}</template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
          @pagination="pagination" />
      </div>
    </div>

    <!-- Mostrar colunas -->
    <Modal v-model="showSelectColumns" width="lg">
      <div slot="header">Mostrar colunas</div>
      <p>Selecione as colunas que deseja visualizar na tabela de contas:</p>
      <table class="columnsSelector table table-borderless table-border table-align">
        <thead>
          <tr>
            <th></th>
            <th>Nome da Coluna</th>
            <th>Descrição</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="column in sortedTableColumns" :key="column.key"
            @click="column.checked = !column.checked; updateColumnsInLocalStorage()" style="cursor: pointer;">
            <td><input type="checkbox" :id="column.key" v-model="column.checked" class="cursor-pointer" /></td>
            <td>{{ column.label }}</td>
            <td>{{ column.description }}</td>
          </tr>
        </tbody>
      </table>
    </Modal>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import Modal from '@/components/shares/specialTag/Modal'
import CheckedModels from '@/mixins/CheckedModels'
import ModelMapper from '@/mixins/ModelMapper'
import GetUser from '@/mixins/GetUser'
import GlobalLoading from '@/mixins/GlobalLoading'

import Pagination from '@/components/shares/specialTag/Pagination'
import AccountTagsPopover from '@/components/admin/accounts/AccountTagsPopover'

import Formatter from '@/models/Formatter'
import Sorter from '@/models/Sorter'
import { Filter } from '@/models/filter'
import { getAppDisplayName } from '@/appDisplayNames'
import { ACCOUNT_STATUS_OPTIONS, accountStatusBadgeClass, translateAccountStatus } from '@/utils/accountStatus'
import { DEFAULT_TAG_COLOR, tagTextColor } from '@/utils/accountTags'
import { deletionLabelFor } from '@/models/accountRetention'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'

const tagPath = 'admin/account_tags'

const keyTableColumns = 'adminAccountsTableColumns.v3'
const keyPreviousTableColumns = 'adminAccountsTableColumns.v2'
const keyLegacyTableColumns = 'adminAccountsTableColumns'
const fiveYearsInMinutes = 60 * 24 * 30 * 12 * 5

const APP_STATUS_LABELS = {
  trial: 'em teste',
  installed: 'instalado',
  install: 'instalado',
  active: 'ativo',
  requested: 'requisitado',
  request: 'requisitado',
  pending: 'pendente',
  canceled: 'cancelado',
  expired: 'expirado'
}

const APP_STATUS_BADGES = {
  installed: 'badge-success',
  install: 'badge-success',
  active: 'badge-success',
  trial: 'badge-info',
  requested: 'badge-warning',
  request: 'badge-warning',
  pending: 'badge-warning',
  canceled: 'badge-danger',
  expired: 'badge-secondary'
}

const tableColumns = [
  { key: 'id', label: 'ID', checked: true, description: 'ID da conta' },
  { key: 'name', label: 'Nome', checked: true, description: 'Nome da conta' },
  { key: 'accountStatus', label: 'Status da conta', checked: false, description: 'Status da assinatura da conta' },
  { key: 'tags', label: 'Tags', checked: true, description: 'Tags vinculadas à conta' },
  { key: 'accountType', label: 'Tipo', checked: false, description: 'Tipo de conta (parceira ou não)' },
  { key: 'uf', label: 'UF', checked: true, description: 'Unidade federativa' },
  { key: 'cityCode', label: 'Código cidade', checked: false, description: 'Código da cidade' },
  { key: 'address', label: 'Endereço', checked: false, description: 'Endereço completo' },
  { key: 'responsibleName', label: 'Responsável', checked: false, description: 'Nome do responsável' },
  { key: 'step', label: 'Passo da conta', checked: false, description: 'Etapa do cadastro da conta' },
  { key: 'phone', label: 'Telefone', checked: false, description: 'Telefone de contato' },
  { key: 'businessArea', label: 'Área de atuação', checked: false, description: 'Área de atuação da empresa' },
  { key: 'appName', label: 'App', checked: true, description: 'Serviço/APP da conta' },
  { key: 'appStatus', label: 'Status do App', checked: true, description: 'Status do serviço (trial, installed, canceled, expired, request)' },
  { key: 'appTrialAt', label: 'Ativado período de teste em', checked: false, description: 'Data de ativação do período de teste' },
  { key: 'appExpirationAt', label: 'Expiração do período de teste em', checked: false, description: 'Data de expiração do período de teste' },
  { key: 'domain', label: 'Domínio', checked: false, description: 'Domínio da conta' },
  { key: 'subscriptionStart', label: 'Vigência a partir de', checked: false, description: 'Início da vigência do contrato' },
  { key: 'accountDeletion', label: 'Exclusão da conta', checked: false, description: 'Prazo até a exclusão dos dados da conta' },
  { key: 'createdAt', label: 'Criado em', checked: true, description: 'Data de criação da conta' },
  { key: 'updatedAt', label: 'Atualizado em', checked: true, description: 'Data de atualização da conta' },
  { key: 'actions', label: 'Ações', checked: true, description: 'Ações disponíveis' }
]

export default {
  components: { AccountTagsPopover, BadgeFilters, BkpsCheckBox, ChevronDownIcon, Modal, Pagination, SearchIcon },
  computed: {
    accounts() {
      return this.getModels || []
    },
    availableTagOptions() {
      return this.tags.filter(tag => !this.query.tagIds.includes(tag.id))
    },
    rows() {
      return this.accounts.map((account, index) => {
        const app = account.accountApp || null
        return { account, app, appKey: app ? app.id : `none-${index}` }
      })
    },
    selectedColumns() {
      return this.tableColumns.filter(column => column.checked)
    },
    sortedTableColumns() {
      return Sorter.sortBy(this.tableColumns, 'label')
    },
    badgeFilters() {
      return [
        this.filterEndDate,
        this.filterStartDate,
        this.filterStep,
        this.filterAppName,
        this.filterAccountAppStatus,
        this.filterSubscriptionType
      ]
    },
    changeQueryAndHasNumberOfBadges() {
      return this.changeQuery
    },
    disabledReport() {
      return this.meta.totalCount === 0 || (!this.checkAll && !this.accounts.some(a => a.checked))
    }
  },
  created() {
    const initialValues = ['accountType', 'periodType', 'step', 'appName', 'accountAppStatus', 'subscriptionType']
    initialValues.forEach(key => this.$set(this.query, key, ''))
    this.$set(this.query, 'tagIds', [])

    this.methods = ['tags']
    this.loadTags()

    this.$set(this.query, 'expandApps', true)

    this.initializersTableColumns()
    this.find()
  },
  data: () => ({
    tags: [],
    showSelectColumns: false,
    tableColumns: tableColumns,
    filterAcccountType: new Filter({
      key: 'accountType',
      label: 'Tipo de conta',
      table: [
        ['Todas', ''],
        ['Conta parceira', 'partner'],
        ['Conta não parceira', null]
      ]
    }),
    filterAppName: new Filter({
      key: 'appName',
      label: 'App',
      table: [
        ['Todos', ''],
        ['Aplicação', 'application'],
        ['DF-e', 'dfe'],
        ['CM-Frotas', 'cm-frotas'],
        ['CM-Taxas', 'cm-taxas'],
        ['CM-Crono', 'cm-crono'],
        ['CM-Embarcador', 'cm-embarcador'],
        ['Indicação de Condutores', 'driver-indication']
      ]
    }),
    filterAccountAppStatus: new Filter({
      key: 'accountAppStatus',
      label: 'Status do app',
      table: [
        ['Todos', ''],
        ['Instalado', 'installed'],
        ['Expirado', 'expired'],
        ['Cancelado', 'canceled'],
        ['Requisitado', 'requested']
      ]
    }),
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterStep: new Filter({
      key: 'step',
      label: 'Passo',
      table: [
        ['Todos', ''],
        ['1 - Criando nome da conta', '1'],
        ['2 - Dados cadastrais da empresa', '2'],
        ['3 - Seleção de área de atuação', '3'],
        ['4 - Cadastro de Matriz e Filiais', '4'],
        ['5 - Ativação de módulos', '5'],
        ['6 - Inserção de certificado digital', '6'],
        ['7 - Confirmação certificado digital', '7'],
        ['8 - Finalizado', '8'],
      ]
    }),
    filterSubscriptionType: new Filter({
      key: 'subscriptionType',
      label: 'Status da conta',
      table: [['Todos', ''], ...ACCOUNT_STATUS_OPTIONS.map(o => [o.label, o.value])]
    }),
    modelPathPrefix: 'admin',
    nameModel: 'Account',
    orderBy: 'created_at'
  }),
  methods: {
    accountStatusBadgeClass,
    translateAccountStatus,
    appStatusLabel(status) {
      return APP_STATUS_LABELS[status] || status || '-'
    },
    appStatusBadgeClass(status) {
      return APP_STATUS_BADGES[status] || 'badge-secondary'
    },
    cellValue(row, column) {
      const { account, app } = row

      switch (column.key) {
        case 'id': return account.id
        case 'name': return account.name || '-'
        case 'accountType': return account.accountType || '-'
        case 'uf': return account.uf || '-'
        case 'cityCode': return account.cityCode || '-'
        case 'address': return account.address || '-'
        case 'phone': return account.phone || '-'
        case 'responsibleName': return account.responsibleName || '-'
        case 'step': return account.step != null ? account.step : '-'
        case 'businessArea': return account.businessArea || '-'
        case 'appName': return app ? (getAppDisplayName(app.name) || app.nickname || app.name) : '-'
        case 'appTrialAt': return app && app.trialAt ? Formatter.stringToDatetime(app.trialAt) : '-'
        case 'appExpirationAt': return app && app.expirationAt ? Formatter.stringToDatetime(app.expirationAt) : '-'
        case 'domain': return account.domain || '-'
        case 'subscriptionStart': return account.subscriptionStart ? Formatter.stringToDate(account.subscriptionStart) : '-'
        case 'accountDeletion': return deletionLabelFor(account.deletionBaseAt) || '-'
        case 'createdAt': return account.createdAt ? Formatter.stringToDatetime(account.createdAt) : '-'
        case 'updatedAt': return account.updatedAt ? Formatter.stringToDatetime(account.updatedAt) : '-'
        default: return '-'
      }
    },
    initializersTableColumns() {
      const keys = this.$ls.get(keyTableColumns) || this.migratePreviousColumns() || this.migrateLegacyColumns()
      if (!keys) return
      this.tableColumns.forEach(column => { column.checked = keys.includes(column.key) })
    },
    migratePreviousColumns() {
      return this.$ls.get(keyPreviousTableColumns)
    },
    migrateLegacyColumns() {
      const legacy = this.$ls.get(keyLegacyTableColumns)
      return legacy && [...legacy, 'tags']
    },
    updateColumnsInLocalStorage() {
      const selectedKeys = [...new Set(this.tableColumns.filter(c => c.checked).map(c => c.key))]
      this.$ls.set(keyTableColumns, selectedKeys, { minutes: fiveYearsInMinutes })
    },
    buildLink(account) {
      if (account.accountType === 'partner')
        return `/admin/partner_accounts/${account.id}`

      return `/admin/accounts/${account.id}`
    },
    changeCheckAll() {
      this.changeCheck({ checkAll: !this.checkAll, sources: this.accounts })
    },
    changeCheckAllRow(value) {
      this.changeCheck({ checkAllRow: value, sources: this.accounts })
    },
    changeCheckRow() {
      this.changeCheck({ sources: this.accounts })
    },
    createReport() {
      let params
      let amount

      if (this.checkAll) {
        params = this.buildParams()
        amount = this.meta.totalCount
      } else {
        const ids = [...new Set(this.accounts.filter(a => a.checked).map(a => a.id))]
        params = { q: { id: ids, expand_apps: true } }
        amount = ids.length
      }

      if (!confirm(`Exportar ${amount} Conta(s).\nTem certeza?`))
        return

      this.openGlobalLoad()
      this.axios.get('admin/accounts/report', { params })
        .then(response => {
          if (response.data)
            this.$parse.downloadByLink(response.data)
          else
            this.$notify.add(response.meta.notice)
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    find() {
      this.asyncTemplateSelect()
    },
    sendPartnerAccount(id = 'new') {
      this.$router.push({ path: `/admin/partner_accounts/${id}` })
    },
    tagTextColor,
    loadTags() {
      return this.axios.get(tagPath, { params: { meta: false, per_page: 200 } })
        .then(response => this.tags = response.data || [])
        .catch(e => this.$notify.addError(e))
    },
    accountTags(account) {
      return account.tags || []
    },
    accountTagIds(account) {
      return this.accountTags(account).map(tag => tag.id)
    },
    tagColor(tagId) {
      const tag = this.tags.find(t => t.id === tagId)
      return tag ? tag.color : DEFAULT_TAG_COLOR
    },
    tagName(tagId) {
      const tag = this.tags.find(t => t.id === tagId)
      return tag ? tag.name : ''
    },
    associateTags(account, tagIds) {
      const tags = this.tags.filter(tag => tagIds.includes(tag.id))

      this.axios.post(`admin/accounts/${account.id}/set_tags`, { tag_ids: tagIds })
        // A conta se repete numa linha por app, então atualiza todas de uma vez.
        .then(() => this.accountRowsOf(account).forEach(row => this.$set(row, 'tags', [...tags])))
        .catch(e => this.$notify.addError(e))
    },
    accountRowsOf(account) {
      return this.accounts.filter(candidate => candidate.id === account.id)
    },
    refreshTags() {
      this.loadTags().then(() => {
        this.syncAccountTags()

        const removed = this.query.tagIds.filter(id => !this.tags.some(t => t.id === id))
        if (!removed.length) return

        this.query.tagIds = this.query.tagIds.filter(id => this.tags.some(t => t.id === id))
        this.find()
      })
    },
    syncAccountTags() {
      this.accounts.forEach(account => {
        const tags = this.accountTagIds(account)
          .map(id => this.tags.find(tag => tag.id === id))
          .filter(Boolean)

        this.$set(account, 'tags', tags)
      })
    },
    addTagFilter(value) {
      const tagId = Number(value)
      if (!value || this.query.tagIds.includes(tagId)) return

      this.query.tagIds.push(tagId)
      this.find()
    },
    removeTagFilter(tagId) {
      const index = this.query.tagIds.indexOf(tagId)
      if (index === -1) return

      this.query.tagIds.splice(index, 1)
      this.find()
    }
  },
  mixins: [CheckedModels, ModelMapper, GetUser, GlobalLoading],
  name: 'AdminAccountsIndex',
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      const direction = ['name', 'id'].includes(newValue) ? 'asc' : 'desc'
      this.addOrderBy(newValue, direction)
      this.find()
    }
  }
}
</script>

<style scoped>
  .badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    color: white;
    white-space: nowrap;
  }
  .badge-success { background-color: #28a745; }
  .badge-warning { background-color: #FFC866; color: #051B30; }
  .badge-danger { background-color: #dc3545; }
  .badge-info { background-color: #318BE3; }
  .badge-secondary { background-color: #6c757d; }

  .tags-cell {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
  }

  .tag-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1.2;
  }

  .selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .tag-badge-remove {
    margin-left: 6px;
    cursor: pointer;
    font-weight: 700;
    line-height: 1;
  }

  .tag-badge-remove:hover {
    opacity: 0.7;
  }
</style>
